import { Component, OnInit } from '@angular/core';
import {PodcastItem} from "../../../editor/podcast-item";
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {

  constructor(private http: HttpClient, private router: Router) { }

  private
    list:PodcastItem[] = [];

  ngOnInit() {
      this.http
          .post('/list', { } ).subscribe(
          (result: any[]) => {
              // this.list = <PodcastItem[]>result;
              result.forEach( (item) => {
                  let podItem = new PodcastItem();
                  podItem.id = item.id;
                  podItem.name = item.name;
                  this.list.push(podItem);
              });

              this.list = this.list.slice(0, 10);
          });
  }

}
